// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oq-1";
export var stateContainer = "_oq-0";